import React, { FC } from "react";
import { ICardQuote } from "./types";
import {
  CORNER_ELEMENT_AFTER,
  CORNER_ELEMENT_BEFORE,
} from "src/constants/cornerElement";
import cn from "classnames";

export const CardQuote: FC<ICardQuote> = ({ quote }) => (
  <div
    className={cn(
      "absolute bottom-0 left-0 right-[25%] md:right-[18%] bg-green-base border-green-base border-t-20 border-r-20 rounded-tr-15",
      CORNER_ELEMENT_BEFORE,
      "before:-top-11.25 before:left-0 before:shadow-corner-bottom-left-green-base",
      CORNER_ELEMENT_AFTER,
      "after:bottom-0 after:-right-11.25 after:shadow-corner-bottom-left-green-base"
    )}
  >
    <div className="bg-white-base flex justify-center items-center px-2 md:px-8 h-18 md:h-36 rounded-15">
      <p className="text-green-base text-8 md:text-12 leading-none font-medium">
        {quote}

        <span className="absolute top-0 left-1.5 md:left-3 text-32 md:text-48 font-spaceland font-bold">
          &quot;
        </span>
      </p>
    </div>
  </div>
);
